import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@klickdata/core/auth';
import { Customer } from '@klickdata/core/customer';
import { MessageSavedComponent, MessageService } from '@klickdata/core/message';
import { MobileService, SideNaveActionsTypes, SideNaveDataTypes } from '@klickdata/core/mobile';
import { OccasionsDates, Resource } from '@klickdata/core/resource';
import {
    Filter,
    GlobalFilterProperty,
    GlobalFilterPropertyType,
    SelectFilterOption,
    TableFilterComponent,
} from '@klickdata/core/table';
import { User, UserActionHistory } from '@klickdata/core/user';
import { ResourceApprovalsListingService } from '@klickdata/core/user-messages/src/user-messages/user-messages-center/user-messages-approvals/resource-approvals-listing.service';
import { Utils } from '@klickdata/core/util';
import { UserTableBaseComponent } from '@klickdata/shared-components/src/user-table-base/user-table-base.component';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { LocalStorageService } from 'ngx-webstorage';
import { filter, Observable, switchMap, takeUntil } from 'rxjs';

@Component({
    selector: 'app-instructor-waiting-users-listing',
    templateUrl: './instructor-waiting-users-listing.component.html',
    styleUrls: ['./instructor-waiting-users-listing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ResourceApprovalsListingService],
})
export class InstructorWaitingUsersListingComponent extends OnDestroyHandler implements AfterViewInit, OnInit {
    @ViewChild('tableBase') tableBase: UserTableBaseComponent;
    @Input() authUser: User;
    @Input() tableFilterItems: Filter<any>[];
    @Input() approvalStatus: string;
    @Input() resource: Resource;
    @Output() onUpdateStatus: EventEmitter<void> = new EventEmitter();
    @ViewChild('name', { static: true }) name: TemplateRef<any>;
    @ViewChild('img', { static: true }) img: TemplateRef<any>;
    @ViewChild('registred_date', { static: true }) registred_date: TemplateRef<any>;
    @ViewChild('tools', { static: true }) tools: TemplateRef<any>;
    @ViewChild('change_occasion', { static: true }) changeOccasionControlRef: TemplateRef<any>;
    Utils = Utils;
    public changeOccasionControl = new FormControl(null);
    public allOccasions: OccasionsDates[] = [];
    public selectedUserOccasionId: number;
    @ViewChild(TableFilterComponent) filter: TableFilterComponent;
    GlobalFilterPropertyType = GlobalFilterPropertyType;
    public isMobile$: Observable<boolean>;
    public customer$: Observable<Customer>;
    public expandedRowId: number | null;
    GlobalFilterProperty = GlobalFilterProperty;
    columnsData: { [key: string]: TemplateRef<any> } = {};
    otherContext: { [key: string]: TemplateRef<any> } = {};
    public approvalStatusOptions: SelectFilterOption[];
    columnsKeys: any = {
        name: { label: $localize`Name`, sortable: true },
        img: { label: '', sortable: true },
        registred_date: { label: $localize`Enrollment Date`, sortable: true, icon: 'edit_calendar' },
    };
    private storage = inject(LocalStorageService);
    expandedFn = (user: User) => (user.opportunity_id || user.id) === this.expandedRowId;

    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected cdr: ChangeDetectorRef,
        protected mobile: MobileService,
        protected auth: AuthService,
        protected messageService: MessageService,
        protected resourceEnrollmentsListingService: ResourceApprovalsListingService
    ) {
        super();
        this.isMobile$ = mobile.isMobile();

        this.approvalStatusOptions = Utils.getResApprovalStatusOptions();
    }
    ngOnInit(): void {
        this.route.queryParams
            .pipe(
                filter((params) => params.expand),
                takeUntil(this.destroy)
            )
            .subscribe((params) => {
                setTimeout(() => {
                    this.expandedRowId = +params.expand;
                    this.cdr.markForCheck();
                }, 500);
            });
        this.customer$ = this.auth.getCustomer();
        setTimeout(() => {
            if (this.approvalStatus) {
                this.filter.setActiveFilterWithSelectedOption(GlobalFilterProperty.REVIEW_STATUS, this.approvalStatus);
            } else {
                this.filter.clear();
            }
        }, 100);
        this.allOccasions = this.resource.enrollmentRequiredMetadata?.occasion_dates ?? [];
    }
    ngAfterViewInit(): void {
        this.columnsData['img'] = this.img;
        this.columnsData['name'] = this.name;
        this.columnsData['registred_date'] = this.registred_date;
        this.columnsData['tools'] = this.tools;
    }

    browse(user: User) {
        this.router.navigate(['/admin/accounts/users/users/' + user.id + '/actions']);
    }
    public sendMsg(user: User) {
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.SEND_MESSAGE,
            data: { model: user, isUser: true },
        });
    }

    onSelectStats(user: User) {
        this.router.navigate(['/admin/statistics/course-results/users'], {
            queryParams: {
                user_id: user.id,
            },
        });
    }

    sendEmail(user: User) {
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.SEND_MAIL,
            data: user,
        });
    }
    onMessageSelected() {
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.SEND_MESSAGE,
            data: { models: this.tableBase.dataSource.data, isMultipleUsers: true },
        });
    }
    onEmailSelected() {
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.EMAIL_MULTIPLE_USERS,
            data: {
                type: 'emailMultipleUsers',
                users: this.tableBase.dataSource.data,
            },
        });
    }

    expansionToggled(user: User) {
        this.expandedRowId = this.expandedRowId === user.id ? null : user.id;
    }
    changeOccasion(user: User) {
        this.selectedUserOccasionId = user.enrollment?.metadata?.occasion_id;
        this.changeOccasionControl.setValue(this.selectedUserOccasionId);
        this.mobile.updateSideNavSub({
            dataType: SideNaveDataTypes.GENERAL_NOTIFIER,
            data: {
                icon: 'change_circle',
                title: $localize`Change occasion`,
                contentBody: $localize`You are about to change occasion of ${user.name}.`,
                positiveBtn: $localize`Done`,
                injectedTemplate: this.changeOccasionControlRef,
                negativeBtn: $localize`Cancel`,
            },
        });
        this.mobile
            .getSideNavAction()
            .pipe(
                filter((action) => action === SideNaveActionsTypes.POSITIVE),
                filter(() => this.changeOccasionControl.value !== this.selectedUserOccasionId),
                switchMap(() =>
                    this.resourceEnrollmentsListingService.changeOccasion(
                        [user.enrollment.collaboration_id],
                        this.changeOccasionControl.value
                    )
                )
            )
            .subscribe(() => {
                this.storage.clear(UserActionHistory.SELECTED_HOME_TABS_RESOURCE_OCCASION_ID);
                this.messageService.openMessage(MessageSavedComponent, $localize`Occasion changed successfully.`);
                this.onUpdateStatus.emit();
            });
    }
}
